const BANNED_PATTERNS = [
  /\beval\b/,
  /\bFunction\b/,
  /\bsetTimeout\b/,
  /\bsetInterval\b/,
  /\bdocument\b/,
  /\bwindow\.(?!__PHASER)/,
  /\bfetch\b/,
  /\bXMLHttpRequest\b/,
  /\blocalStorage\b/,
  /\bsessionStorage\b/,
  /\bimport\s*\(/,
]

const BLOCK_COUNT_LIMIT = 200

export class ValidationError extends Error {
  constructor(message) {
    super(message)
    this.name = 'ValidationError'
  }
}

export function validateGeneratedCode(code) {
  for (const pattern of BANNED_PATTERNS) {
    if (pattern.test(code)) {
      throw new ValidationError(
        `Kode mengandung pola terlarang: ${pattern.source}. ` +
          `Kalau menurutmu ini bug, hubungi tim TM.`,
      )
    }
  }
}

export function validateBlockCount(workspace) {
  const count = workspace.getAllBlocks(false).length
  if (count > BLOCK_COUNT_LIMIT) {
    throw new ValidationError(`Terlalu banyak blok (${count}). Maksimum ${BLOCK_COUNT_LIMIT}.`)
  }
}

export function validateTopLevelEvents(workspace) {
  const topBlocks = workspace.getTopBlocks(false)
  const eventTypes = [
    'event_when_start',
    'event_when_sprite_clicked',
    'event_when_collide',
    'event_when_key',
    'event_every_n_seconds',
  ]
  for (const block of topBlocks) {
    if (!eventTypes.includes(block.type)) {
      throw new ValidationError(
        `Blok teratas harus dari kategori Events. Ditemukan: "${block.type}".`,
      )
    }
  }
}
